import { Flex, TextV2, styled } from '@withjoy/joykit';

export const StyledSurveyWrapper = styled(Flex)``;
export const StyledSurveyContent = styled(Flex)``;
export const StyledSurveyTitle = styled(TextV2)``;
export const StyledSurveyDescription = styled(TextV2)``;
export const StyledSurveyError = styled(TextV2)``;
export const StyledSurveyButtonWrapper = styled(Flex)<{ layout?: 'horizontal' | 'vertical' }>`
  flex-direction: ${props => {
    return props.layout === 'vertical' ? 'column' : 'row';
  }} !important;
  gap: ${props => (props.layout === 'vertical' ? '12px' : '8px')} !important;
  width: 100%;
`;
export const StyledSurveyChexboxListWrapper = styled(Flex)``;
